import React from 'react';
import { Oval as Loader } from 'react-loader-spinner';

/**
 * Fixed-height row above the oldest messages. Height never changes between states
 * so scroll position stays stable while older history loads.
 *
 * Observed by the scroll hook (IntersectionObserver) to trigger history loads.
 *
 * States (mutually exclusive, loader wins):
 * - Loader: older messages are actively being fetched
 * - Beginning: homeserver confirmed there is no further history
 * - Spacer: idle (stable height, no label)
 */
const ChatHistoryStatus = React.forwardRef(function ChatHistoryStatus(
  { isLoadingOlder = false, isAtConversationStart = false },
  ref
) {
  const showLoader = Boolean(isLoadingOlder);
  const showBeginning = !showLoader && Boolean(isAtConversationStart);
  const isSpacer = !showLoader && !showBeginning;

  let ariaLabel;
  if (showLoader) ariaLabel = 'Loading earlier messages';
  else if (showBeginning) ariaLabel = 'Beginning of conversation';

  return (
    <div
      ref={ref}
      className="chat_history_status"
      role="status"
      aria-live="polite"
      aria-busy={showLoader}
      aria-hidden={isSpacer || undefined}
      aria-label={ariaLabel}
      data-loading={showLoader ? 'true' : 'false'}
      data-at-start={showBeginning ? 'true' : 'false'}
    >
      {showLoader ? (
        <Loader color="#F334BE" height={18} width={18} />
      ) : showBeginning ? (
        <span>Beginning of conversation</span>
      ) : null}
    </div>
  );
});

export default React.memo(ChatHistoryStatus);
